// extracted by mini-css-extract-plugin
export default {"switch":"styles_switch__Bcw3S","item":"styles_item__+ee5y","active":"styles_active__eh5W6"};